import { HeavyAdService } from 'common/services/heavy-ad-service';
import { FormatState } from 'common/stores/FormatStateStore';
import eventBus from 'common/event-handling/event-bus.model';
import { PreloadErrorEvent } from 'common/event-handling/events';
import globalConfig from 'common/js/config';
import { AnalyticsStore } from 'common/stores';

export class HeavyAdHandler {
  private heavyAdService?: HeavyAdService;

  constructor(
    private readonly formatContext: AdContext,
    private readonly formatState: FormatState
  ) {
    this.handle();
  }

  handle() {
    if (window.isOgyPreview) return;
    if (!window.frameElement) return;

    this.heavyAdService = new HeavyAdService(
      (window.frameElement as unknown) as HTMLIFrameElement,
      () => {
        if (!this.formatContext) return;

        const {
          campaignId,
          creativeId,
          advertiserId,
          impressionId,
          adUnitType
        } = this.formatContext;

        if (this.formatState === FormatState.Loading) {
          eventBus.publish(new PreloadErrorEvent());
        }

        const heavyAdQueryParams = {
          e_campaign_id: campaignId,
          e_creative_id: creativeId.toString(),
          video_event: 'heavy_ad_intervention',
          advertiser_id: advertiserId,
          e_advert_id: impressionId,
          app_ssp: 'ogury',
          ad_unit_type: adUnitType ?? ''
        };

        // Note: the /video endpoint was always used from mweb tag regardless of the media type. It doesn't really matter as the way it's used on ads-monitoring is
        // just to raise slack alerts on specific line item / creative
        const heavyAdMonitoringEndpoint = new URL(
          globalConfig.MS_ADS_MONITORING_EVENTS_URL + '/video'
        );
        heavyAdMonitoringEndpoint.search = new URLSearchParams(
          heavyAdQueryParams
        ).toString();

        AnalyticsStore.instance?.sendTrack(
          heavyAdMonitoringEndpoint.toString()
        );
      }
    );

    this.heavyAdService.listenToHeavyAdIntervention();
  }
}
